import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import {
    BlobTypeStoreReadSettingsAdapter,
    blobTypeStoreReadSettingsAdapts
} from './blob-type-store-read-settings.adapter';
import { SharePointOnlineFileStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/sharepoint-online-file-store-read-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SharePointOnlineFileStoreReadSettings),
    asynchronous: true,
    adapts: blobTypeStoreReadSettingsAdapts
})
export class SharePointOnlineFileStoreReadSettingsAdapter extends BlobTypeStoreReadSettingsAdapter<
    SharePointOnlineFileStoreReadSettings,
    Model.StoreReadSettings
> {
    protected override async _toModel(
        resource: Model.StoreReadSettings,
        copySource: CopySource
    ): Promise<SharePointOnlineFileStoreReadSettings> {
        return super._toModel(resource, copySource);
    }

    protected override async _toResource(
        settings: SharePointOnlineFileStoreReadSettings
    ): Promise<Model.StoreReadSettings> {
        return super._toResource(settings);
    }
}
